<mat-form-field class="allwidth">
  <mat-label>{{ 'IBAN' | translate}}</mat-label>
    <input matInput [value]="ngControl.control.value" [disabled]="true" class="one">
    <i matSuffix *ngIf="ngControl?.control.enabled" class="glyphicon glyphicon-new-window link" (click)="selectUserIban()"></i>
</mat-form-field>
<error [control]="ngControl?.control"></error>
